// @ts-nocheck
import { post } from "@insite/client-framework/Services/ApiService";

export interface GetWishListIdsByProductIdsApiParameter {
    Products: {
        ProductId: string;
    }[];
}
export interface GetWishListIdsByProductIdsApiResult {
    productWishListIds: {
        productId: string;
        wishListIds: string[];
    }[];
}
const endPoint = "/api/v1/WishListBulk";

export const getWishListIdsByProductIds = async (params: GetWishListIdsByProductIdsApiParameter) => {
    const data = await post<GetWishListIdsByProductIdsApiParameter, GetWishListIdsByProductIdsApiResult>(
        `${endPoint}/`,
        params,
    );
    return data;
};

export const addProductToLists = async (productId: string, wishListIds: string[]) => {
    await post(`${endPoint}/add`, {
        ProductId: productId,
        WishListIds: wishListIds,
    });
};

export const removeProductFromLists = async (productId: string, wishListIds: string[]) => {
    await post(`${endPoint}/remove`, {
        ProductId: productId,
        WishListIds: wishListIds,
    });
};
